export default "__VITE_ASSET__BPI0p2AE__";